<div class="row row-sm ">
  <div class="col-lg-12">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12" *ngIf="submitButton">
          <div class="bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
            <div class="ml-2">
              <h3 class="main-content-label mb-1"><b>
                  {{ 'header.code-type-data.table.CodeTypeL' | translate }}
                </b></h3>
              <p class="text-muted card-sub-title mb-0">
                {{ 'header.code-type-data.table.AddNewCodeTypeInformation' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="editButton">
          <div class="bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
            <div class="ml-2">
              <h3 class="main-content-label mb-1"><b>
                {{ 'header.code-type-data.table.CodeTypeL' | translate }}
                </b></h3>
              <p class="text-muted card-sub-title mb-0">
                {{ 'header.code-type-data.table.UpdateSelectedCodeTypeInformation' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="deleteButton">
          <div class="bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
            <div class="ml-2">
              <h3 class="main-content-label mb-1"><b>
                {{ 'header.code-type-data.table.CodeTypeL' | translate }}
                </b></h3>
              <p class="text-muted card-sub-title mb-0">
                {{ 'header.code-type-data.table.DeleteSelectedCodeTypeInformation' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="row row-sm add-form mt-3">
          <mat-tab-group (selectedTabChange)="onTabChanged($event)" (next)="next()" [selectedIndex]="selectedIndex"
            mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="{{'header.code-type-data.table.CodeType' | translate}}">
              <div>
                <form autocomplete="off" novalidate class="p-0" novalidate [formGroup]="codetypeForm">
                  <div class="col-lg-12 col-md-12">
                    <div class="mt-3">
                      <div class="row clearfix mt-3">
                        <div class="col-sm-4">
                          <div class="form-group">
                            <div class="">
                              <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>
                                  {{'header.code-type-data.table.CourseCode'
                                  | translate }}</mat-label> <input onkeydown="return (event.keyCode!=13);" matInput
                                  formControlName="CdType" maxlength="5" placeholder="Code"
                                  [readonly]="isReadonlyDelete" [readonly]="isReadonly" required>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdType'].touched && codetypeForm.controls['CdType'].errors?.required">
                                  {{ 'header.code-type-data.table.Mandatory' | translate }} </mat-error>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdType'].touched && codetypeForm.controls['CdType'].errors?.pattern">
                                  {{ 'header.code-type-data.table.Invalid' | translate }}
                                </mat-error>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdType'].touched && codetypeForm.controls['CdType'].errors?.maxlength">
                                  Enter maximum 6 digit code
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <div class="">
                              <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{
                                  'header.code-type-data.table.CodeSequence'
                                  | translate }}</mat-label> <input onkeydown="return (event.keyCode!=13);" matInput
                                  maxlength="4" formControlName="CdSeq" [readonly]="isReadonlyDelete"
                                  placeholder="Code Sequence" required type="text">
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdSeq'].touched && codetypeForm.controls['CdSeq'].errors?.required">
                                  {{ 'header.code-type-data.table.Mandatory' | translate }} </mat-error>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdSeq'].touched && codetypeForm.controls['CdSeq'].errors?.pattern">
                                  {{ 'header.code-type-data.table.Invalid' | translate }}
                                </mat-error>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdSeq'].touched && codetypeForm.controls['CdSeq'].errors?.maxlength">
                                  Enter maximum 4 digits
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <div class="">
                              <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{
                                  'header.code-type-data.table.CodeProc'
                                  | translate }}</mat-label> <input onkeydown="return (event.keyCode!=13);" matInput
                                  formControlName="CdProc" [readonly]="isReadonlyDelete" placeholder="CdProc"
                                  maxlength="25" required>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdProc'].touched && codetypeForm.controls['CdProc'].errors?.required">
                                  {{ 'header.code-type-data.table.Mandatory' | translate }} </mat-error>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdProc'].touched && codetypeForm.controls['CdProc'].errors?.pattern">
                                  {{ 'header.code-type-data.table.Invalid' | translate }}
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <div class="">
                              <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{
                                  'header.code-type-data.table.CodeDescription'
                                  | translate }}</mat-label> <input onkeydown="return (event.keyCode!=13);" matInput
                                  formControlName="CdDesc" maxlength="150" [readonly]="isReadonlyDelete"
                                  placeholder="Code Description" required>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdDesc'].touched && codetypeForm.controls['CdDesc'].errors?.required">
                                  {{ 'header.code-type-data.table.Mandatory' | translate }} </mat-error>
                                <mat-error class="margin_tp"
                                  *ngIf="codetypeForm.controls['CdDesc'].touched && codetypeForm.controls['CdDesc'].errors?.pattern">
                                  {{ 'header.code-type-data.table.Invalid' | translate }}
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <div class="">
                              <div class="row">
                                <div class="col-sm-3 mt-3">
                                  <mat-label class="mt-1 lclass"><span
                                      class="required-asterisk mr-1">{{'header.code-type-data.table.CodeActive'
                                      | translate}}</span>
                                  </mat-label>
                                </div>
                                <div class="col-sm-7 mt-3">
                                  <mat-radio-group [disabled]="isReadonlyDelete" onkeydown="return (event.keyCode!=13);"
                                    formControlName="CdActive" class="example-full-width">
                                    <div class="row">
                                      <div class="col-sm-5">
                                        <mat-radio-button value='Y'>
                                          {{'header.code-type-data.table.Yes'
                                          | translate}}
                                        </mat-radio-button>
                                      </div>
                                      <div class="col-sm-5">
                                        <mat-radio-button value='N'>
                                          {{'header.code-type-data.table.No'
                                          | translate}}
                                        </mat-radio-button>
                                      </div>
                                    </div>
                                  </mat-radio-group>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-2 prpl">
                          <div class="col-sm-8"></div>
                          <div class="col-sm-2 prpl ">
                            <button id="Back" type="button" [mat-dialog-close]="true"
                              class="btn btn-primary btn-icon-text floatright mt-1">
                              <span style="display: contents; align-items: center;">
                                <img width="20vh"  src="../../assets/img/turn-left.gif" style="margin-right: 5px;">
                                {{ 'header.code-type-data.table.Back' | translate }}
                              </span>
                            </button>
                          </div>
                          <div class="col-sm-2 prpl" *ngIf="submitButton && CodeCreate">
                            <button id="Save" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                              (click)="submit()">
                              <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                {{ 'header.code-type-data.table.Save' | translate }}
                              </span>
                            </button>
                          </div>
                          <div class="col-sm-2 prpl" *ngIf="editButton && CodeUpdate">
                            <button id="Update" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                              (click)="update()">
                              <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                {{ 'header.code-type-data.table.Update' | translate }}
                              </span>
                            </button>
                          </div>
                          <div class="col-sm-2 prpl" *ngIf="deleteButton && CodeDelete">
                            <button id="Delete" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                              (click)="openConformationModalBox()">
                              <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                {{ 'header.code-type-data.table.Delete' | translate }}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </mat-tab>
            <mat-tab label="Code" [disabled]="CodeDisabled" *ngIf="CodeTypeView">
              <app-code-dialog-box (prev)="prev()"></app-code-dialog-box>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>